import { requestGet, requestPost } from '../utils/request'

// const baseURL = 'http://192.168.2.17:8082';
const baseURL = 'http://s.lianty.cn'; // 外网
// 登陆
export const login = (params) => requestPost(baseURL + '/site/login', params )
// 获取图形验证码
export const getAuthCodeBase64 = (params) => requestGet(baseURL + '/systemCodeCategory/getAuthCodeBase64', params )

